import React from "react";
import { getFunctions, httpsCallable ,connectFunctionsEmulator} from "firebase/functions";
import { loadStripe } from "@stripe/stripe-js";


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const SubscribeButton = ({ priceId }) => {
  // Connect to Firebase Emulator in Development Mode
  const handleSubscribe = async () => {
    try {
      const functions = getFunctions();
      if (process.env.NODE_ENV === "development") {
        // console.log('connecting to local host')
        connectFunctionsEmulator(functions, "localhost", 5001);
      }
      const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");

      const result = await createCheckoutSession({
        priceId,
        successUrl: window.location.origin + "/success",
        cancelUrl: window.location.origin + "/cancel",
      });

      const stripe = await stripePromise;
      await stripe.redirectToCheckout({
        sessionId: result.data.sessionId,
      });
    } catch (error) {
      console.error("Error starting checkout:", error);
      alert("Failed to start checkout session.");
    }
  };

  return (
    <button
      onClick={handleSubscribe}
      className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700"
    >
      Subscribe Now
    </button>
  );
};

export default SubscribeButton;
